"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var styles = __importStar(require("../ColoradoAcademyVeterinary.module.css"));
var Header = (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.prototype.render = function () {
        return (React.createElement("header", { className: styles.header },
            React.createElement("div", { className: styles.sectionHeader },
                React.createElement("img", { src: "/img/cavt.png", alt: "cavt-logo" })),
            React.createElement("div", { className: styles.sectionName },
                React.createElement("h3", null,
                    React.createElement("strong", null, "Colorado Academy")),
                React.createElement("p", null,
                    React.createElement("strong", null, "Veterinary Technology")))));
    };
    return Header;
}(react_1.Component));
exports.Header = Header;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhZGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvQ29sb3JhZG9BY2FkZW15VmV0ZXJpbmFyeS9jb21tb24tY29tcG9uZW50cy9IZWFkZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSwyQ0FBOEI7QUFDOUIsK0JBQStCO0FBQy9CLDhFQUFpRTtBQUVqRTtJQUE0QiwwQkFBUztJQUFyQzs7SUFrQkEsQ0FBQztJQWpCRyx1QkFBTSxHQUFOO1FBQ0ksT0FBTyxDQUNILGdDQUFRLFNBQVMsRUFBRSxNQUFNLENBQUMsTUFBTTtZQUM1Qiw2QkFBSyxTQUFTLEVBQUUsTUFBTSxDQUFDLGFBQWE7Z0JBQ2hDLDZCQUFLLEdBQUcsRUFBQyxlQUFlLEVBQUMsR0FBRyxFQUFDLFdBQVcsR0FBRyxDQUN6QztZQUNOLDZCQUFLLFNBQVMsRUFBRSxNQUFNLENBQUMsV0FBVztnQkFDOUI7b0JBQ0ksdURBQWlDLENBQ2hDO2dCQUNMO29CQUNJLDREQUFzQyxDQUN0QyxDQUNGLENBQ0QsQ0FDWixDQUFBO0lBQ0wsQ0FBQztJQUNMLGFBQUM7QUFBRCxDQUFDLEFBbEJELENBQTRCLGlCQUFTLEdBa0JwQztBQWxCWSx3QkFBTSJ9